import { ReactNode } from 'react';
import { SingleMedia } from '@/shared/types/strapi.types';
import { MetaData } from '@/store/api/meta/meta.type';
import {
  EmailIcon,
  EmailPurple,
  GlobeIcon,
  GlobePurple,
  WhitePhoneIcon,
  PhonePurple,
  TV,
  TVPurple,
  WiFi,
  WiFiPurple,
  // PlugIcon,
  // PlugIconPurple,
  FamilyHome,
  FamilyHomePurple,
  RouterIcon,
  RouterIconPurple,
  RubIcon,
  PhoneTariff,
  InfinitySmallIcon,
  InfinitySmallPurpleIcon,
  SimcardOption,
} from '@/shared/assets/svg';
import StartLogo from 'public/assets/img/kinomaniya/START.svg';
import PremierLogo from 'public//assets/img/kinomaniya/Premier.svg';
import VijuLogo from 'public/assets/img/kinomaniya/viju.svg';

export const MOYA_STRANA = {
  NAME: 'moya-strana',
  LOCALIZED_NAME: 'Моя страна',
};

export interface AccordionDataType {
  id: number;
  title: string;
  subtitle: string;
  items: AccordionItemsType[];
}

export interface AccordionItemsType {
  id: number;
  price: string;
  text: string;
  desc: string;
}

export interface Prices {
  convergent_price?: number | null;
  mono_price?: number | null;
  promotion_price?: number | null;
  evpatoria_price?: number | null;
  price_apartment?: number | null;
  price_house?: number | null;
}

export type ResourceBalance = {
  value: string,
  icon: TariffOptionIcon,
  text: string,
  from?: boolean
};

export interface TariffType {
  name: string;
  localized_name: string;
  background_image: SingleMedia;
  text: string;
  banner_desktop: SingleMedia;
  banner_tablet: SingleMedia;
  banner_mini: SingleMedia;
  accordion_data: AccordionDataType[];
  priority: number;
  isArchived: boolean;
  offer_file?: SingleMedia;
  meta_data: MetaData;
}

export enum TARIFF_TYPE {
  ACTIVE = 'active',
  ARHIVE = 'archive',
}

const TARIFF_LABEL = {
  [TARIFF_TYPE.ACTIVE]: 'Актуальные',
  [TARIFF_TYPE.ARHIVE]: 'Архивные',
};

export const TariffTypeData = [
  { value: String(TARIFF_TYPE.ACTIVE), label: TARIFF_LABEL[TARIFF_TYPE.ACTIVE] },
  { value: String(TARIFF_TYPE.ARHIVE), label: TARIFF_LABEL[TARIFF_TYPE.ARHIVE] },
];

export enum TITLES {
  MOBILE = 'Мобильная связь',
  HOME_INTERNET = 'Домашний интернет',
  BEAUTIFUL_NUMBER = 'Красивый номер',
}

export enum TariffOptionIcon {
  Phone = 'phone',
  Globe = 'globe',
  Email = 'email',
  Tv = 'tv',
  Speed = 'speed',
  Router = 'router',
  Connection = 'connection',
  Rub = 'rub',
  PhoneTariff = 'phoneTariff',
  Sim = 'sim',
  Unlimited = 'unlimited',
}

export const TariffOptionIconsWhite: Record<TariffOptionIcon, ReactNode> = {
  phone: <WhitePhoneIcon />,
  email: <EmailIcon />,
  globe: <GlobeIcon />,
  tv: <TV />,
  speed: <WiFi />,
  // connection: <PlugIcon />,
  connection: <FamilyHome />,
  router: <RouterIcon />,
  rub: <RubIcon />,
  phoneTariff: <PhoneTariff />,
  sim: <SimcardOption />,
  unlimited: <InfinitySmallIcon />,
};

export const TariffOptionIconsPurple: Record<TariffOptionIcon, ReactNode> = {
  phone: <PhonePurple />,
  email: <EmailPurple />,
  globe: <GlobePurple />,
  tv: <TVPurple />,
  speed: <WiFiPurple />,
  // connection: <PlugIconPurple />,
  connection: <FamilyHomePurple />,
  router: <RouterIconPurple />,
  rub: <RubIcon />,
  phoneTariff: <PhoneTariff />,
  sim: <SimcardOption />,
  unlimited: <InfinitySmallPurpleIcon />,
};

export const KINOMANIYA_NAME = 'kinomaniya';

export const ONLINE_CINEMA_LOGOS = {
  start: <StartLogo />,
  premier: <PremierLogo />,
  viju: <VijuLogo />,
};

export const ONLINE_CINEMAS_TITLE = 'Онлайн-кинотеатры';
